<script>
import { mapActions } from "vuex";
import LoadingSpinner from "../../../components/LoadingSpinner.vue";

export default {
  components: {
    LoadingSpinner
  },

  data() {
    return {
      questions: [],
      questionsControl: true,
      token: "",
      user: "",
      textQuestions: "",
      companyId: "",
      company_name: "CompanyName",
      answersElement: [],
      userName: "",
      userSurname: "",
      userEmail: "",
      surveyName: "",
      surveyDesc: "",
      showThanks: false,
      su2SurveyId: "",
      showFullText: false,
      limitSentences: 2,
      showDots: false,
      responseMessage : "",
      disablePost: false,

      companyLogo: null,

      tooltip: {
        environment: {
          text: "ENVIRONMENT DESCRIPTION TOOLTIP",
          class: "env-tooltip"
        },
        product_quality_and_technology: {
          class: "product-tooltip"
        },
        custom_selections: {
          class: "custom-select-tooltip"
        },
        social_responsibility: {
          class: "social-responsibility-tooltip"
        },
        corporate_governance: {
          class: "corp-tooltip"
        },
      },


      languages: [
          {
              value: "en",
              text: "English",
              shortText: "EN",
          },
          {
              value: "tr",
              text: "Türkçe",
              shortText: "TR",
          }
      ],
      
      selectedLanguage: "en",

      loading: false,

      question_points: [1,2,3,4,5],
      
      /* [1,6]
      [7,12]
      [13,16]
      [17,20] */


      clientWidth: window.innerWidth,
    };
  },
  computed: {
    limitedText() {
      const sentences = this.surveyDesc.split(".").filter(Boolean);
      return sentences.slice(0, this.limitSentences).join(". ") + ".";
    },
    allInputsSelected() {
      for (let i = 0; i < this.questions.length; i++) {
        if (!this.questions[i].value) {
          return false;
        }
      }
      if (!this.textQuestions) {
      return false;
    }

      return true;
    },

    textMessage(){
      return ([
        {
          lang: 'en',
          _01: `Dear Valued Stakeholder,`,
          _02: `At ${this.company_name}, we are committed to fostering sustainability in all aspects of our operations. 
              Your opinions and insights play an integral role in shaping our sustainability priorities and reporting strategies.`,
          _03: `We have prepared a special survey to assess our sustainability priorities, 
              in line with the Global Reporting Initiative (GRI) standards. 
              Our goal is to create a Materiality Matrix, 
              which will help us identify and prioritize the most significant sustainability topics for our company.`,
          _04: `The sustainability topics have been carefully selected, taking into account our industry and corporate needs. 
                As a valued stakeholder, your feedback on these topics is invaluable.`,
          _05: `For each sustainability topic, you will be asked to rate its importance and relevance to our business on a scale of 1 to 5. 
                A rating of 1 indicates a lower priority, while a rating of 5 suggests that the topic is of the utmost importance.`,
          _06: `Please complete the survey as thoroughly as possible, and feel free to provide any additional comments or insights. 
                Your feedback will be instrumental in guiding our sustainability strategies.`,
          _07: `Thank you for taking the time to participate in this survey. 
                Your collaboration is an essential part of our ongoing sustainability journey.`,
          _08: `Warm regards,`,
          _09: `What are your opinions, thoughts and suggestions regarding the company's sustainability efforts?`,
          _10: `Send`,
          _11: `THANK YOU...`,
          _12: `SURVEY SUCCESSFULLY COMPLETED`,
          _13: `Thank you for your contribution`,
          _14: `YOU CAN CLOSE THIS WINDOW`,
          low_prio: "Low Priority",
          hi_prio: "High Priority"
        },
        {
          lang: 'tr',
          _01: `Değerli Paydaşımız,`,
          _02: `${this.company_name} olarak, iş operasyonlarımızın her alanında sürdürülebilirliği teşvik etmeye kararlıyız.
              Görüşleriniz ve bilgileriniz, sürdürülebilirlik önceliklerimizi ve raporlama stratejilerimizi şekillendirmede önemli bir rol oynamaktadır.`,
          _03: `Küresel Raporlama İnisiyatifi (GRI) standartları doğrultusunda sürdürülebilirlik önceliklerimizi değerlendirmek amacıyla özel bir anket hazırladık.
              Amacımız, bir Önemlilik (Materiality) Matrisi oluşturmak ve şirketimiz için en önemli sürdürülebilirlik konularını belirlemek ve önceliklendirmektir.`,
          _04: `Sürdürülebilirlik konuları, endüstri ve kurumsal ihtiyaçlarımızı dikkate alarak özenle seçilmiştir.
                Değerli bir paydaşımız olarak, bu konulardaki geri bildiriminiz bizim için çok önemlidir.`,
          _05: `Aşağıdaki ankette, her sürdürülebilirlik konusu için firmamızın çalışmalarına olan önemini ve ilgisini, 
              1 en düşük ve 5 en yüksek öneme sahip olmak üzere, 1 ile 5 arasında bir ölçekte değerlendirmenizi istiyoruz.`,
          _06: `Cevaplarınız, işletmemizin sürdürülebilirlik stratejilerini geliştirmemize ve 
                sizinle daha yakın bir işbirliği içinde olmamıza yardımcı olacaktır. 
                Bu nedenle, görüşlerinizi açıkça paylaşmanızı ve anketi dikkatle yanıtlamanızı rica ediyoruz.`,
          _07: `Sürdürülebilirlik yolculuğumuzun önemli bir parçası olan önceliklendirme çalışmamıza zaman ayırdığınız için teşekkür ederiz.`,
          _08: `Saygılarımızla,`,
          _09: `Firmamızın sürdürülebilirlik çalışmaları hakkında görüşleriniz, yorumlarınız ve önerileriniz nelerdir?`,
          _10: `Gönder`,
          _11: `TEŞEKKÜR EDERİZ...`,
          _12: `ANKET BAŞARIYLA TAMAMLANDI`,
          _13: `Katılımınız için teşekkür ederiz`,
          _14: `BU PENCEREYİ KAPATABİLİRSİNİZ`,
          low_prio: "Düşük Öncelikli",
          hi_prio: "Yüksek Öncelikli"
        }
      ]);
    },

    showElement() {
      return this.clientWidth > 768;
    },

  },
  watch: {
    showFullText() {
      if (this.showFullText) {
        this.limitSentences = this.surveyDesc.split(".").length;
        this.showDots = false;
      } else {
        this.limitSentences = 2;
        this.showDots = true;
      }
    },
  },
  methods: {
    ...mapActions("surveys", [
      "getUserToken",
      "postUserInfo",
      "sendSurveyAnswers",
      "getCompanyLogoByCompanyId"
    ]),
    getSurveys() {
      let params = {
        token: this.$route.query.token,
        user: this.$route.query.user,
        id: this.$route.query.id,
        language: this.selectedLanguage,
      };
      this.getUserToken(params)
        .then((res) => {
          this.su2SurveyId = res.data[0].su2_survey_id;
          this.questions = res.data[0].questions;
          this.surveyName = res.data[0].su2_survey_name;
          this.surveyDesc = res.data[0].survey_text;
          this.company_name = res.data[0].company_name;
          this.questionsControl = false;
          this._getCompanyLogoByCompanyId(res.data[0].company_id);
        })
        .catch(({ response }) => {
          this.responseMessage = this.$parseResMessage(response.data.messageName)
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },

    _getCompanyLogoByCompanyId(companyId) {
      const params = {
        company_id: companyId
      }

      this.getCompanyLogoByCompanyId(params)
        .then( res => {
          const blob = res.data;
          const fileReader = new FileReader();
          fileReader.readAsDataURL(blob);
          fileReader.onloadend = () => {
            this.companyLogo = fileReader.result;
          }
        })
        .catch(({ response }) => {
          console.error("No company logo found!");
        })
    },

    userInfo() {
      let params = {
        user_id: this.$route.query.user,
      };
      this.postUserInfo(params)
        .then((res) => {
          this.companyId = res.data[0].company_id;
          this.userName = res.data[0].firstname;
          this.userSurname = res.data[0].surname;
          this.userEmail = res.data[0].email;
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    postSurveys() {
      if (this.disablePost === true) return;

      this.disablePost = true;
      this.answersElement = this.questions;
      const newAnswersElement = this.answersElement.map(
        ({
          sust_element_name,
          sust_element_description,
          sust_element_id,
          ...otherProps
        }) => {
          const { value, ...restProps } = otherProps;
          return { ...restProps, answer: value };
        }
      );
      let params = {
        su2_survey_id: this.su2SurveyId,
        company_id: this.companyId,
        completed_by: this.$route.query.user,
        answers: newAnswersElement,
        su2_text_answer: this.textQuestions,
      };
      this.sendSurveyAnswers(params)
        .then((res) => {
          this.showThanks = true;
          this.questionsControl = true;
          this.$toast.open({
            message: this.$parseResMessage(res.data.messageName),
            type: "success",
            duration: 5000,
            dismissible: true,
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        })
        .finally(() => {
          this.disablePost = false;
        });
    },

    handleResize() {
      this.clientWidth = window.innerWidth;
    },

    getColor(id){
      if (id == 1){
        return '#ffa500'
      }
      if (id == 2){
        return '#61a60e'
      }
      if (id == 3){
        return '#d93434'
      }
      if (id == 4){
        return '#6262c3'
      }
    },
    getClass(id){
      if (id == 1){
        return 'env-tooltip'
      }
      if (id == 2){
        return 'product-tooltip'
      }
      if (id == 3){
        return 'social-responsibility-tooltip'
      }
      if (id == 4){
        return 'corp-tooltip'
      }
    },

    selectLanguage(item) {
        this.selectedLanguage = item.value;
        
        this.loading = true;
        setTimeout(() => {
            this.loading = false;
        }, 500);
    },

    normalizeLanguage(lang) {
      const normalized = lang.split("-")[0];
      return normalized;
    },
    
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);

    this.selectedLanguage = this.normalizeLanguage(navigator.language);

    if (this.selectedLanguage.includes("en") || this.selectedLanguage.includes("tr")) {
      this.selectedLanguage = this.selectedLanguage;
    } else {
      this.selectedLanguage = "en";
    }

    this.getSurveys();
    this.userInfo();
    (this.userName = ""), (this.userEmail = ""), (this.userSurname = "");
    (this.surveyName = ""), (this.surveyDesc = "");
  },
};
</script>

<template>
  <div class="flex-all-centered-col" style="height: 100vh; justify-content: flex-start; overflow: auto;">
    <div v-if="questionsControl">
      <div>
        <h1>{{responseMessage}}</h1>
      </div>
    </div>

    <div v-else class="flex-all-centered-col" style="width: 50%;">
      <div v-if="loading">
        <loading-spinner />
      </div>

      <div class="flex-all-centered-row language-selection-wrapper">
        <div class="inner-language-selection-wrapper">
          <select class="language-select" v-model="selectedLanguage" @change="getSurveys">
            <option v-for="item in languages" :key="item.value" :value="item.value">
              <span v-if="showElement">{{ item.text }}</span>
              <span v-else>{{ item.shortText }}</span>
            </option>
          </select>
          <i class="mdi mdi-translate language-icon"></i>
        </div>
      </div>

      <div class="flex-all-centered-row">
        <a class="navbar-brand" href="https://www.sustainfinity.com/" target="_blank">
          <img
            style="height:100px; width:110px" src="/images/sustainfinity_512x512.png"
            alt="sustainfinity-logo" 
          />
        </a>

        <div class="flex-all-centered-col" style="max-width: fit-content; margin: 0 5vw 0 5vw; font-size: 1vw;">
          <div class="flex-all-centered-col">
            <div>
              {{ userName }}
              {{ userSurname }}
            </div>
            <div>
              {{ userEmail }}
            </div>
          </div>

          <div>
            <ul>
              <span>{{ surveyName }}</span>
            </ul>
          </div>
        </div>

        <div style="width: 50px; margin-left: 10px;">
          <img :src="companyLogo" style="width: 50px;">
        </div>
      </div>

      <div class="flex-all-centered-col">
        <div style="text-align: center">
          <div style="text-align: justify; hyphens: auto; text-justify: inter-word">

            <div class="text-left">
              <b>{{ textMessage.find(item => item.lang == selectedLanguage)._01 }}</b> <br><br>
              <!-- TODO: ADD BROWSER LANGUAGE -->

              {{ textMessage.find(item => item.lang == selectedLanguage)._02 }}
              <br><br>

              {{ textMessage.find(item => item.lang == selectedLanguage)._03 }}
              <br><br>

              <span>
                {{ textMessage.find(item => item.lang == selectedLanguage)._04 }}
                <br><br>

                {{ textMessage.find(item => item.lang == selectedLanguage)._05 }}
                <br><br>

                {{ textMessage.find(item => item.lang == selectedLanguage)._06 }}
                <br><br>

                {{ textMessage.find(item => item.lang == selectedLanguage)._07 }}
                <br><br>

                <div style="right: 2em; bottom: -2em;">
                  <b>{{ textMessage.find(item => item.lang == selectedLanguage)._08 }}</b>
                  <br>
                  <b>{{ company_name }}</b>
                </div>
              </span>

            </div>
          </div>
        </div>

        <div class="survey-points-section">

          <div class="question flex-all-centered-row">
            <div style="max-width: 30px" class="question-tooltip flex-all-centered-col">
              
            </div>

            <div class="question-val">
              
            </div>

            <div
              v-for="point in question_points" 
              :key="point"
              style="flex: 1; margin: 0 1vw !important; text-align: center"
            >
              {{ point }}
            </div>
          </div>
          
          <!-- <div class="points-wrapper" style="border-bottom: 2px solid #023047;">
            <div>
              <div>
                {{ textMessage.find(item => item.lang == selectedLanguage).low_prio }}
              </div>
              <div v-for="(item, index) in [1,2,3,4,5]" :key="index">
                {{ item }}
              </div>
              <div>
                {{ textMessage.find(item => item.lang == selectedLanguage).hi_prio }}
              </div>
            </div>
          </div> -->
          
          <div v-for="(id, i) in questions" class="question flex-all-centered-row" :key="i">
            <div style="max-width: 30px"
              :style="{'backgroundColor': getColor(id.sust_element_category_id)}" class="question-tooltip flex-all-centered-col"
            >
              <i class="mdi mdi-information" style="color: white; cursor: help;" v-b-tooltip.hover.bottom="{  }"
                :title="id.sust_element_description"></i>
            </div>

            <div style="font-weight: 800;" :style="{'color': getColor(id.sust_element_category_id)}" class="question-val">
              {{ id.sust_element_name }}
            </div>

            <input 
              type="radio"
              v-for="point in question_points" 
              :key="point" 
              :value="point"
              v-model="id.value"
              :name="`${id.sust_element_name}`"
              :style="{'accent-color': getColor(id.sust_element_category_id)}"
            />
          </div>

        </div>
        <b-row style="text-align: center">
          <b-col sm="12">
            <label for="textarea-default">
              {{ textMessage.find(item => item.lang == selectedLanguage)._09 }}
            </label>
          </b-col>

          <b-col sm="12">
            <b-form-textarea id="textarea-default" placeholder="Answer" v-model="textQuestions"></b-form-textarea>
          </b-col>
        </b-row>
        <br /><br />
        <b-button @click="postSurveys" style="float: right" pill variant="success" size="sm"
          :disabled="!allInputsSelected || disablePost">
          <span v-if="!disablePost">{{ textMessage.find(item => item.lang == selectedLanguage)._10 }}<b-icon
              icon="arrow-right"></b-icon></span>
          <span v-else><LoadingSpinner /></span>
        </b-button>
      </div>
      <br /><br />
      <br /><br />
    </div>

    <div class="bgimg">
      <div class="middle survey-end-text" v-show="showThanks" style="color: #44a900; font-weight: 400;">
        <h1 style="font-weight: 400;">{{ textMessage.find(item => item.lang == selectedLanguage)._11 }}</h1>
        <hr>
        <h1 style="font-weight: 400;">{{ textMessage.find(item => item.lang == selectedLanguage)._12 }}</h1>
        <p>{{ textMessage.find(item => item.lang == selectedLanguage)._13 }}</p>
        <hr>
        <footer>{{ textMessage.find(item => item.lang == selectedLanguage)._14 }}</footer>
      </div>
    </div>
  </div>

</template>

<style lang="scss">
body {
  background-color: #f4f3ef !important;
}
::selection {
  color: #fff;
  background-color: #61a60e;
}

::-moz-selection {
  color: #fff;
  background-color: #61a60e;
}

.navbar {
  padding: 0;
}

.navbar-brand img {
  height: 80px;
  width: auto;
  display: block;
}

.navbar-toggler {
  float: right;
  border: none;
  padding-right: 0;
}

.navbar-toggler:active,
.navbar-toggler:focus {
  outline: none;
}

input[type="radio"] {
  margin: 0 10px 0 10px;
}


label {
  display: block;
  line-height: 40px;
}

.option-input {
  -webkit-appearance: none;
  appearance: none;
  top: 5.33333px;
  height: 20px !important;
  width: 20px !important;
  transition: all 0.15s ease-out 0s;
  background: #cbd1d8;
  border: none;
  color: #fff;
  cursor: pointer;
}

.option-input:hover {
  background: #61a60e;
}

.option-input:checked {
  background: #61a60e;
}

.option-input:checked::before {
  width: 20px;
  height: 20px;
  display: flex;
  content: "\f00c";
  font-size: 25px;
  font-weight: bold;
  position: absolute;
  align-items: center;
  justify-content: center;
  font-family: "Font Awesome 5 Free";
}

.option-input:checked::after {
  animation: click-wave 0.65s;
  background: #61a60e;
  content: "";
  display: block;
  position: relative;
  z-index: 100;
}

.option-input.radio {
  border-radius: 50%;
}

.option-input.radio::after {
  border-radius: 50%;
}

@keyframes click-wave {
  0% {
    height: 40px;
    width: 40px;
    opacity: 0.35;
    position: relative;
  }

  100% {
    height: 200px;
    width: 200px;
    margin-left: -80px;
    margin-top: -80px;
    opacity: 0;
  }
}

/* loading */

#circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 150px;
  height: 150px;
}

.loader {
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  border: 8px solid #162534;
  border-top: 8px solid #61a60e;
  border-radius: 50%;
  animation: rotate 5s linear infinite;
}

.questions-wrapper {
  justify-content: space-between
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
      #circle {
        width: 100px;
        height: 100px;
      }
    }
    .centered-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

@media screen and (max-width: 800px) {
  .survey-points-section {
    font-size: 12px !important;
  }
  .option-input.radio {
    height: 12px !important;
    width: 12px !important;
  }
  .tooltip-info-square {
    width: 20px !important;
  }
  .points {
    max-width: 20px !important;
  }
}
@media screen and (max-width: 540px) {
  .survey-points-section {
    font-size: 10px !important;
  }
  .option-input.radio {
    height: 10px !important;
    width: 10px !important;
  }
  .tooltip-info-square {
    width: 10px !important;
  }
  .points {
    max-width: 6px !important;
  }
  .questions-wrapper {
    justify-content: space-around !important;
    flex-wrap: nowrap !important;
  }
}
@media screen and (max-width: 450px) {
  .survey-points-section {
    font-size: 8px !important;
  }
  .option-input.radio {
    height: 10px !important;
    width: 10px !important;
  }
  .tooltip-info-square {
    width: 10px !important;
  }
  .points {
    max-width: 6px !important;
  }
  .questions-wrapper {
    justify-content: space-around !important;
    flex-wrap: nowrap !important;
  }
}

.points-placement {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;

  position: relative;
  width: 100%;

  > .points-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;

    position: absolute;
    top: -2em;
    right: 15%;

    > .points {
      width: 2.9em;
      height: 2em;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
    }
    
  }
}

.language-selection-wrapper {
  z-index: 999;
  padding: 1em;
  justify-content: flex-end !important;

  .inner-language-selection-wrapper {
    position: relative;
    width: 7.5%;
    min-width: 150px;

    > select {
      padding: .5em;
      
      width: 100%;
      height: fit-content;

      border: 0;

      outline: thin solid var(--sustainfinity-navy);

      border-radius: 1em;
    }
  
    > .language-icon {
      position: absolute;
      right: 1em;
      top: 35%;
      transform: translate(0, -50%);
      font-size: 1.33em;
      color: var(--sustainfinity-navy);
    }
  }     
}

.question {
  border-bottom: thin solid var(--sustainfinity-navy);
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: center !important;
  align-items: stretch !important;

  > .question-tooltip {
    flex: 3;
  }

  > .question-val {
    flex: 22;
    padding: .3vw;
  }

  > input {
    flex: 1;
    margin: 0 1vw !important;
  }
}

.low-prio-ctr, .high-prio-ctr {
  position: absolute;
}

.high-prio-ctr {
  right: 0;
  transform: translateX(120%);
}

.low-prio-ctr {
  left: 0;
  transform: translateX(-75%);
}

@media screen and (max-width: 1200px){
  .language-selection-wrapper {

  }

  .points-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;

    position: absolute;
    top: -2em;
    right: 11.5% !important;

  }

  .points {
      width: 2em;
      height: 2em;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
  }
}
@media screen and (max-width: 990px){
  .points-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;

    position: absolute;
    top: -2em;
    right: 4.25% !important;

  }

  .points {
      width: 2em;
      height: 2em;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
  }
}


@media screen and (max-width: 768px) {
  .language-selection-wrapper {
    min-width: 80px;
  }
  .question-text {
    font-size: .8em;
  }
  .radio-buttons {
    max-width: 100px;
  }
  .radio {
    width: 15px !important;
    height: 15px !important;
  }
  input[type="radio"] {
    margin: 0 2px 0 2px;
  }

  .points-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;

    position: absolute;
    top: -2em;
    right: 14.25% !important;

  }

  .points {
      width: 1.35em !important;
      height: 2em;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
  }

}
@media screen and (max-width: 535px) {
  .question-text{
    max-width: 375px !important;
  }

  .radio-buttons {
    position: absolute;
    right: 4.5em;
  }

  .radio {
    width: 15px !important;
    height: 15px !important;
  }
  input[type="radio"] {
    margin: 0 2px 0 2px;
  }

  .points-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;

    position: absolute;
    top: -2em;
    right: 14.25% !important;

  }

  .points {
      width: 1.35em !important;
      height: 2em;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
  }

}
@media screen and (max-width: 480px) {
  .question-text{
    max-width: 250px !important;
  }

  .radio-buttons {
    position: absolute;
    right: 3.5em;
  }

  .radio {
    width: 15px !important;
    height: 15px !important;
  }
  input[type="radio"] {
    margin: 0 2px 0 2px;
  }

  .points-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;

    position: absolute;
    top: -2em;
    right: 14.25% !important;

  }

  .points {
      width: 1.35em !important;
      height: 2em;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
  }

}


</style>